import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { kontaktModel } from "../../../api/models/kontaktModel";
import { useQueryWithPopupErrorHandling } from "../../../providers/utils/hooks";
import { Auth } from "../../../ts/Auth";
import { Obrat } from "../../../ts/Obraty";
import ReduxState from "../../../ts/Redux";
import Criteria from "./Criteria";
import Header from "./Header";
import "./Obraty.scss";
import ObratyTable from "./ObratyTable";

type TFilterValue = {
  value: any;
  label: string;
};

export interface Filter {
  kontakt: TFilterValue | undefined;
  skupina: TFilterValue | undefined;
  obec: TFilterValue | undefined;
  okres: TFilterValue | undefined;
  obchodnik: TFilterValue | undefined;
  rok: TFilterValue | undefined;
  mesic: TFilterValue | undefined;
}

const FilterCriteriaWrapper = React.createContext<
  [Filter[], (filterCriteria: Filter[]) => void]
>([[], () => null]);

export const useFilterCriteria = () => {
  return React.useContext(FilterCriteriaWrapper);
};

const ObratyWrapper = React.createContext<[Obrat[], (val: Obrat[]) => void]>([
  [],
  () => null,
]);

export const useObraty = () => {
  return React.useContext(ObratyWrapper);
};

interface Props {
  auth: Auth;
}

const Obraty: React.FC<Props> = ({ auth }: Props) => {
  const [filterCriteria, setFilterCriteria] = useState<Filter[]>([]);
  const { kontakt } = useParams();
  const { call } = useQueryWithPopupErrorHandling();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  useEffect(() => {
    if (kontakt) {
      call(
        () => kontaktModel.getKontaktById(kontakt),
        null,
        null,
        (k) => {
          setFilterCriteria((f) => [
            ...f,
            {
              kontakt: { value: k._id, label: k.nazev },
              mesic: undefined,
              obchodnik: undefined,
              obec: undefined,
              okres: undefined,
              rok: undefined,
              skupina: undefined,
            },
          ]);
        },
        () => {
          navigate("/obraty");
        }
      );
    }
  }, [kontakt]);

  return (
    <FilterCriteriaWrapper.Provider value={[filterCriteria, setFilterCriteria]}>
      <ObratyWrapper.Provider value={[[], () => null]}>
        <div className="obraty">
          <div className="title">OBRATY</div>
          <Header />
          {filterCriteria.length > 0 ? <Criteria /> : null}
          <ObratyTable filterCriteria={filterCriteria} />
        </div>
      </ObratyWrapper.Provider>
    </FilterCriteriaWrapper.Provider>
  );
};
const mapStateToProps = (state: ReduxState) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(Obraty);
